var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlugType1Medium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24,25c-2.2060547,0-4,1.7939453-4,4s1.7939453,4,4,4s4-1.7939453,4-4S26.2060547,25,24,25z M24,31 c-1.1025391,0-2-0.8974609-2-2s0.8974609-2,2-2s2,0.8974609,2,2S25.1025391,31,24,31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,13c-2.2060547,0-4,1.7939453-4,4s1.7939453,4,4,4s4-1.7939453,4-4S18.2060547,13,16,13z M16,19 c-1.1025391,0-2-0.8974609-2-2s0.8974609-2,2-2s2,0.8974609,2,2S17.1025391,19,16,19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,17c0-2.2060547-1.7939453-4-4-4s-4,1.7939453-4,4s1.7939453,4,4,4S36,19.2060547,36,17z M32,19 c-1.1025391,0-2-0.8974609-2-2s0.8974609-2,2-2s2,0.8974609,2,2S33.1025391,19,32,19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,4C14.6259766,4,7,11.6259766,7,21s7.6259766,17,17,17s17-7.6259766,17-17S33.3740234,4,24,4z M24,36 c-8.2714844,0-15-6.7285156-15-15S15.7285156,6,24,6s15,6.7285156,15,15S32.2714844,36,24,36z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4472656,5.7597656c-4.2226562-4.0048828-9.7724609-6.0332031-15.5908203-5.7294922 C11.9335938,0.6103516,3.0263672,9.9931641,3,20.9482422c-0.0224609,9.3330078,6.1064453,17.5117188,15,20.15625V45 c0,1.6542969,1.3457031,3,3,3h6c1.6542969,0,3-1.3457031,3-3v-3.8955078C38.8701172,38.4658203,45,30.3076172,45,21 C45,15.1787109,42.6728516,9.7666016,38.4472656,5.7597656z M28.75,39.3759766c-0.4414062,0.1142578-0.75,0.5126953-0.75,0.96875 V45c0,0.5517578-0.4482422,1-1,1h-6c-0.5517578,0-1-0.4482422-1-1v-4.6552734c0-0.4560547-0.3085938-0.8544922-0.75-0.96875 C10.8388672,37.2070312,4.9794922,29.6308594,5,20.9521484c0.0244141-9.9101562,8.0820312-18.4003906,17.9619141-18.9238281 C23.3134766,2.0087891,23.6630859,2,24.0107422,2c4.890625,0,9.4941406,1.8291016,13.0605469,5.2109375 C40.8945312,10.8359375,43,15.7333984,43,21C43,29.6552734,37.140625,37.2119141,28.75,39.3759766z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 26,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 26,
    r: 1.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlugType1Medium);
export default __webpack_public_path__ + "static/media/plug-type-1--medium.7f2c438c26af13085b75217ae9c5edd6.svg";
export { ForwardRef as ReactComponent };